<script>
  import { bodyScroll } from "$lib/utils/PreventBodyScroll";
  import { afterUpdate } from "svelte";
  import { page } from "$app/stores";

  import BurgerButton from "./BurgerButton.svelte";
  import Icons from "./Icons.svelte";
  import MobileNav from "./MobileNav.svelte";
  import DesktopNav from "./DesktopNav.svelte";

  let isOpen = false;
  const openCloseMenu = () => (isOpen = !isOpen);
  $: {
    isOpen;
    afterUpdate(() => {
      if (isOpen) {
        bodyScroll.prevent();
      } else {
        bodyScroll.allow();
      }
    });
  }
</script>

<header>
  <div class="header-container" class:pink={$page.url.pathname.includes("/cart")}>
    <button class="mobile-menu" on:click={openCloseMenu}>
      <BurgerButton bind:isOpen />
    </button>
    <div class="logo-container">
      <a href="/" on:click={() => (isOpen = false)} class="logo">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.307 91.716">
          <g id="Grupo_315" data-name="Grupo 315" transform="translate(0)">
            <g id="Grupo_128" data-name="Grupo 128" transform="translate(0)">
              <path
                id="Trazado_111"
                data-name="Trazado 111"
                d="M-21.145-42.949c24.938,0,45.153-20.531,45.153-45.858S3.793-134.665-21.145-134.665-66.3-114.134-66.3-88.807s20.215,45.858,45.153,45.858"
                transform="translate(66.298 134.665)"
                fill="var(--global)"
              />
            </g>
            <g id="Grupo_314" data-name="Grupo 314">
              <g id="Grupo_129" data-name="Grupo 129" transform="translate(18.58 12.28)">
                <path
                  id="Trazado_112"
                  data-name="Trazado 112"
                  d="M-25.882-17.946c-4,6.98-12.495,31.6-29.363,31.6C-65.49,13.651-68.988,6.8-68.988.327c0-11.8,8.746-23.73,8.746-29.821,0-1.268-1.624-4.441-6.623-6.345-2.249,5.077-6.372,13.706-8.372,17.893-1.624,3.3-7.246-.761-5.622-3.173,2.374-3.426,5.5-10.785,7.622-16.622-2.5-.888-4.123-2.539-4.123-7.108,0-5.2,4.372-11.42,11.12-11.42,11.745,0,23.741,8.122,23.741,14.975,0,7.233-5.374,12.562-5.374,20.43,0,3.552,2.125,6.217,7.747,6.217,3.749,0,6.123-2.664,8.622-6.471,2-3.044,7,.763,5.622,3.173"
                  transform="translate(81.151 56.269)"
                  fill="#fcf3e8"
                />
              </g>
              <path
                id="Trazado_113"
                data-name="Trazado 113"
                d="M-6.484-2.561a3.947,3.947,0,0,0-.139-3.424A3.83,3.83,0,0,0-10.466-8a3.867,3.867,0,0,0-3.273,2.968.13.13,0,0,1-.217.071,3.8,3.8,0,0,0-4.176-.589A3.932,3.932,0,0,0-20.3-1.531,3.9,3.9,0,0,0-19.461.416a4.272,4.272,0,0,0,.784.74,3.425,3.425,0,0,0,1.035.5,22.994,22.994,0,0,1,5.972,3.228A1.115,1.115,0,0,0-9.989,4.34l3.306-6.5c.064-.113.123-.227.176-.346a.42.42,0,0,0,.023-.052"
                transform="translate(87.664 39.177)"
                fill="#fcf3e8"
              />
            </g>
          </g>
        </svg>
      </a>
    </div>
    <div class="menu-desktop">
      <DesktopNav />
    </div>
    <div class="icons">
      <Icons />
    </div>
  </div>
</header>

<MobileNav {isOpen} {openCloseMenu} />

<style>
  a {
    text-decoration: none;
    color: inherit;
  }
  button {
    background: none;
    height: 100%;
    aspect-ratio: 1/1;
    border: none;
  }
  header {
    position: fixed;
    width: 95vw;
    max-width: 180rem;
    height: 9rem;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    z-index: 999999;
  }
  .header-container {
    display: grid;
    grid-template-columns: 1fr 70px 1fr;
    padding: 0 15px;
    align-items: center;
    width: 100%;
    height: 100%;
    position: relative;
    align-content: center;
  }
  .header-container::before {
    content: "";
    z-index: -1;
    background-color: var(--orange-light);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 5rem;
    border-radius: 35px;
  }
  .header-container.pink::before {
    background-color: #F5DFE7;
  }
  .mobile-menu,
  .icons {
    height: 4rem;
  }
  .logo-container {
    width: 70px;
    height: 70px;
    aspect-ratio: 1/1;
    justify-self: center;
  }
  .menu-desktop {
    display: none;
  }
  @media (hover: hover) and (min-width: 1024px) {
    header {
      top: 10px;
    }
    .header-container {
      display: grid;
      grid-template-columns: 75px 1fr 120px;
      justify-items: center;
      padding: 0 20px 0 0;
    }
    .header-container::before {
      height: 55px;
    }
    .logo-container {
      width: 75px;
      height: 75px;
    }
    .mobile-menu {
      display: none;
    }
    .menu-desktop {
      display: flex;
      width: 100%;
      padding-left: 8px;
    }
  }
  @media (min-width: 1620px) {
    .header-container {
      display: grid;
      grid-template-columns: 95px 1fr 120px;
    }
    .header-container::before {
      height: 6rem;
      border-radius: 35px;
    }
    .logo-container {
      width: 95px;
      height: 95px;
    }
    .menu-desktop {
      padding-left: 15px;
    }
  }
</style>
